import axios from 'axios';
import { apiBaseUrl } from '../../utils/apiBaseUrl';

export const initiatePasswordReset = async (email: string): Promise<void> => {
  await axios.post(
    `${apiBaseUrl}password-reset/initiate?email=${encodeURIComponent(email)}`,
  );
};
